var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class CustomEvents {
}
__publicField(CustomEvents, "cartUpdate", "cart:update");
__publicField(CustomEvents, "cartNoteUpdate", "cart-note:close");
__publicField(CustomEvents, "quantitySelectorUpdate", "quantity-selector:update");
__publicField(CustomEvents, "discountUpdate", "discount:update");
__publicField(CustomEvents, "variantPickerSelected", "variant-picker:selected");
__publicField(CustomEvents, "variantPickerUpdate", "variant-picker:update");
__publicField(CustomEvents, "FilterUpdate", "filter:update");
__publicField(CustomEvents, "themeAlertOpen", "theme-alert:open");
__publicField(CustomEvents, "cartSectionsToUpdate", "cart:sections-to-update");
__publicField(CustomEvents, "subDrawerOpen", "sub-drawer:open");
/** @static @constant {string} Event triggered when a media (video, 3d model) is loaded */
__publicField(CustomEvents, "mediaStartedPlaying", "media:started-playing");
class SubDrawerOpenEvent extends Event {
  constructor(targetId, trigger) {
    super(CustomEvents.subDrawerOpen, { bubbles: true });
    this.detail = { targetId, trigger };
  }
}
class CartNoteUpdateEvent extends Event {
  constructor() {
    super(CustomEvents.cartNoteUpdate, { bubbles: true });
  }
}
class ThemeAlertOpenEvent extends Event {
  constructor(text, state) {
    super(CustomEvents.themeAlertOpen, { bubbles: true });
    this.detail = {
      text: text || null,
      state: state || null
    };
  }
}
class VariantPickerSelectedEvent extends Event {
  constructor(resource, data) {
    super(CustomEvents.variantPickerSelected, { bubbles: true });
    this.detail = {
      resource,
      data
    };
  }
}
class VariantPickerUpdateEvent extends Event {
  constructor(resource, sourceId, data) {
    super(CustomEvents.variantPickerUpdate, { bubbles: true });
    this.detail = {
      resource: resource || null,
      sourceId,
      data: {
        html: data.html,
        productId: data.productId,
        newProduct: data.newProduct
      }
    };
  }
}
const _CartAddEvent = class _CartAddEvent extends Event {
  constructor(resource, sourceId, data) {
    super(_CartAddEvent.eventName, { bubbles: true });
    this.detail = {
      resource,
      sourceId,
      data: {
        ...data
      }
    };
  }
};
__publicField(_CartAddEvent, "eventName", CustomEvents.cartUpdate);
let CartAddEvent = _CartAddEvent;
class CartUpdateEvent extends Event {
  constructor(resource, sourceId, data) {
    super(CustomEvents.cartUpdate, { bubbles: true });
    this.detail = {
      resource,
      sourceId,
      data: {
        ...data
      }
    };
  }
}
class QuantitySelectorUpdateEvent extends Event {
  constructor(quantity, cartLine) {
    super(CustomEvents.quantitySelectorUpdate, { bubbles: true });
    this.detail = {
      quantity,
      cartLine
    };
  }
}
class DiscountUpdateEvent extends Event {
  constructor(resource, sourceId) {
    super(CustomEvents.discountUpdate, { bubbles: true });
    this.detail = {
      resource,
      sourceId
    };
  }
}
class FilterUpdateEvent extends Event {
  /** @param {URLSearchParams} queryParams */
  constructor(queryParams) {
    super(CustomEvents.FilterUpdate, { bubbles: true });
    this.detail = {
      queryParams
    };
  }
  shouldShowClearAll() {
    return [...this.detail.queryParams.entries()].filter(([key]) => key.startsWith("filter.")).length > 0;
  }
}
class MediaStartedPlayingEvent extends Event {
  /**
   * Creates a new MediaStartedPlayingEvent
   * @param {HTMLElement} resource - The element containing the video that emitted the event
   */
  constructor(resource) {
    super(CustomEvents.mediaStartedPlaying, { bubbles: true });
    this.detail = {
      resource
    };
  }
}
export {
  CustomEvents as C,
  DiscountUpdateEvent as D,
  FilterUpdateEvent as F,
  MediaStartedPlayingEvent as M,
  QuantitySelectorUpdateEvent as Q,
  SubDrawerOpenEvent as S,
  ThemeAlertOpenEvent as T,
  VariantPickerSelectedEvent as V,
  CartUpdateEvent as a,
  CartNoteUpdateEvent as b,
  CartAddEvent as c,
  VariantPickerUpdateEvent as d
};
